import { motion } from 'framer-motion';
import { FaAward, FaLaptopCode, FaBrain, FaCoffee, FaExternalLinkAlt, FaCogs, FaServer } from 'react-icons/fa';
import styles from './About.module.css';

const About = () => {
  // 🔥 Sorted by Impact & Recency
  const certifications = [
    { 
      title: "Build with India Hackathon", 
      issuer: "Hack with India", 
      date: "2024",
      icon: "🏆",
      link: "https://drive.google.com/file/d/1n1qnkmsj73Ghhy6Jb2UE-dep6YwFhgxo/view?usp=drivesdk"
    },
    { 
      title: "Google AI Essentials", 
      issuer: "Google", 
      date: "Oct-2024",
      icon: "🤖",
      link: "https://drive.google.com/file/d/1PcwgzMYLhraegDj-9rfrokSv9td6Z5VC/view?usp=drivesdk"
    },
    { 
      title: "Back-End Development", 
      issuer: "Meta", 
      date: "Feb-2024",
      icon: "⚙️", 
      link: "https://drive.google.com/file/d/1JL5UdB8SvGm_YOt6kkAIEij4NTxnQB3K/view?usp=drivesdk"
    },
    { 
      title: "IBM RAG and Agentic AI", 
      issuer: "IBM", 
      date: "2026",
      icon: "🧠", 
      link: "#"
    },
    { 
      title: "DSA with Java (Elite)", 
      issuer: "NPTEL", 
      date: "Jul-Oct-2024",
      icon: "☕", 
      link: "https://drive.google.com/file/d/1--HYnbhfCaxQDYtMiIH43M567BVbkwCx/view?usp=drivesdk"
    },
    { 
      title: "Java 11 Essentials", 
      issuer: "Infosys", 
      date: "Aug-2024",
      icon: "☕", 
      link: "https://drive.google.com/file/d/1uK38TsxPusk6BzEVn9wHBflY1HfdHdEt/view?usp=drivesdk"
    },
    { 
      title: "Web Development", 
      issuer: "Skill India (NSDC)", 
      date: "Jul-2024",
      icon: "🌐", 
      link: "https://drive.google.com/file/d/1ws19IHNlT7haEh8uRa6E7wkUX4wrpmli/view?usp=drivesdk"
    }
  ];

  return (
    <section id="about" className={styles.aboutSection}>
      <div className={styles.container}>
        
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={styles.header}
        >
          <h2 className="text-gradient">About Me</h2>
          <div className={styles.line}></div>
        </motion.div>

        <div className={styles.contentGrid}>
          
          {/* Left Column: Bio */}
          <motion.div 
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            className={styles.bioColumn}
          >
            <h3 className={styles.subTitle}>
              Engineering solutions with <span className={styles.highlight}>Automation</span> & Code.
            </h3>
            
            <p className={styles.description}>
              Hi, I'm <b>Prince Desai</b>. I don't just write code; I build systems that solve real-world headaches. 
              Starting with the MERN stack, I evolved into a Full Stack Developer who loves building systems with Agentic AI & Automation.
            </p>
            
            {/* <p className={styles.description}>
              Whether it's building a document collection system like *Doc-Flow* or automating boring tasks with Python bots, 
              my goal is always the same: Efficiency.
            </p> */}

            {/* Stats Grid */}
            <div className={styles.statsGrid}>
              <div className={`${styles.statItem} glass`}>
                <FaLaptopCode className={styles.statIcon} />
                <span>Full Stack Dev</span>
              </div>
              <div className={`${styles.statItem} glass`}>
                <FaBrain className={styles.statIcon} />
                <span>AI Enthusiast</span>
              </div>
              <div className={`${styles.statItem} glass`}>
                <FaCoffee className={styles.statIcon} />
                <span>Problem Solver</span>
              </div>
            </div>

            {/* Core Tech Stack Segment */}
            <div className={styles.techSection}>
              <h4 className={styles.techTitle}><FaCogs style={{ marginRight: '8px' }}/> Core Engineering Stack</h4>
              
              <div className={styles.techGrid}>
                
                {/* AI / Data Track */}
                <div className={styles.techCategory}>
                  <h5><FaBrain style={{ marginRight: '8px' }}/> AI & Data</h5>
                  <div className={styles.techTags}>
                    <span className={styles.tagFocus}>Agentic AI</span>
                    <span className={styles.tagFocus}>LangChain</span>
                    <span>RAG / FAISS</span>
                    <span>Gemini API</span>
                    <span>FastAPI</span>
                    <span>Python</span>
                  </div>
                </div>

                {/* Full Stack Track */}
                <div className={styles.techCategory}>
                  <h5><FaServer style={{ marginRight: '8px' }}/> Full Stack Web</h5>
                  <div className={styles.techTags}>
                    <span className={styles.tagFocus}>React 18</span>
                    <span className={styles.tagFocus}>Node.js</span>
                    <span>Express</span>
                    <span>Socket.io</span>
                    <span>MongoDB</span>
                    <span>SQL</span>
                  </div>
                </div>

              </div>
            </div>
          </motion.div>

          {/* Right Column: Certifications (Scrollable) */}
          <motion.div 
             initial={{ x: 50, opacity: 0 }}
             whileInView={{ x: 0, opacity: 1 }}
             viewport={{ once: true }}
             className={styles.certColumn}
          >
            <h3 className={styles.certTitle}>
              <FaAward className={styles.goldIcon} /> Achievements
            </h3>
            
            {/* Scrollable Container */}
            <div className={styles.certScrollContainer}>
              <div className={styles.certList}>
                {certifications.map((cert, index) => (
                  <motion.div 
                    key={index}
                    whileHover={{ scale: 1.02, x: 5 }}
                    className={`${styles.certCard} glass`}
                  >
                    <div className={styles.certIconBox}>{cert.icon}</div>
                    
                    <div className={styles.certContent}>
                      <h4 className={styles.certName}>{cert.title}</h4>
                      <p className={styles.certDetails}>
                        <span className={styles.issuer}>{cert.issuer}</span> • 
                        <span className={styles.date}>{cert.date}</span>
                      </p>
                    </div>

                    <a 
                      href={cert.link} 
                      target="_blank" 
                      rel="noreferrer" 
                      className={styles.viewBtn}
                      title="View Certificate"
                    >
                      <FaExternalLinkAlt />
                    </a>

                    <div className={styles.glowBar}></div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;